import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["onClose", "title", "hideCloseIcon"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import { DialogTitle as MuiDialogTitle, Icon, Grid, Box, RaiseColors, Typography, IconButton } from "components/mui";
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DialogTitle(_ref) {
  var onClose = _ref.onClose,
    title = _ref.title,
    hideCloseIcon = _ref.hideCloseIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(MuiDialogTitle, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs(Grid, {
      container: true,
      children: [/*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: hideCloseIcon ? 12 : 11,
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          weight: "semibold",
          component: "span",
          children: title
        })
      }), !hideCloseIcon && /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 1,
        children: /*#__PURE__*/_jsx(Box, {
          textAlign: "right",
          color: RaiseColors.black,
          children: /*#__PURE__*/_jsx(IconButton, {
            size: "small",
            onClick: onClose,
            edge: "end",
            color: "inherit",
            children: /*#__PURE__*/_jsx(Icon, {
              className: "fal fa-times",
              fontSize: "medium"
            })
          })
        })
      })]
    })
  }));
}